import { Button } from '@fluentui/react-components';
import { useT } from '@powerportalspro/react';
import { SidePanel } from '@powerportalspro/react-fluent';
import { useState } from 'react';

const STRINGS_BASE =
  'components.PowerPortalsPro.Demo.Client.Customizations.Pages.Layout.SidePanel.SidePanelMainDemo';

export function SidePanelMainSample() {
  const t = useT();
  const [open, setOpen] = useState(false);
  const [position, setPosition] = useState<'start' | 'end'>('end');

  const openAt = (at: 'start' | 'end') => {
    setPosition(at);
    setOpen(true);
  };

  return (
    <>
      <div style={{ display: 'flex', gap: '8px' }}>
        <Button appearance="primary" onClick={() => openAt('end')}>
          {t(`${STRINGS_BASE}.open-label`)}
        </Button>
        <Button onClick={() => openAt('start')}>{t(`${STRINGS_BASE}.open-start-label`)}</Button>
      </div>
      <SidePanel
        open={open}
        onOpenChange={setOpen}
        position={position}
        title={t(`${STRINGS_BASE}.panel-title`)}
        widthStorageKey="ppp-demo.side-panel.width"
        footer={<Button onClick={() => setOpen(false)}>{t(`${STRINGS_BASE}.close-label`)}</Button>}
      >
        <p>{t(`${STRINGS_BASE}.panel-body`)}</p>
      </SidePanel>
    </>
  );
}
